import { render, staticRenderFns } from "./WS.vue?vue&type=template&id=316a9b1b&scoped=true"
import script from "./WS.vue?vue&type=script&lang=js"
export * from "./WS.vue?vue&type=script&lang=js"
import style0 from "./WS.vue?vue&type=style&index=0&id=316a9b1b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316a9b1b",
  null
  
)

export default component.exports